import WowzaIcon from './WowzaIcon';
export default WowzaIcon;
